export default "/_next/static/files/abac3e6bd08a1a59e3a3c81170f1caaf.png";